// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BulkAddController from "./bulk_add_controller"
application.register("bulk-add", BulkAddController)

import CalendarInteractionController from "./calendar_interaction_controller"
application.register("calendar-interaction", CalendarInteractionController)

import DatepickerConnectorController from "./datepicker_connector_controller"
application.register("datepicker-connector", DatepickerConnectorController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DeleteConfirmController from "./delete_confirm_controller"
application.register("delete-confirm", DeleteConfirmController)

import DeleteConfirmTriggerController from "./delete_confirm_trigger_controller"
application.register("delete-confirm-trigger", DeleteConfirmTriggerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileDatepickerController from "./mobile_datepicker_controller"
application.register("mobile-datepicker", MobileDatepickerController)

import MultiDatepickerConnectorController from "./multi_datepicker_connector_controller"
application.register("multi-datepicker-connector", MultiDatepickerConnectorController)

import MobileSelectorController from "./mobile_selector_controller"
application.register("mobile-selector", MobileSelectorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonthpickerConnectorController from "./monthpicker_connector_controller"
application.register("monthpicker-connector", MonthpickerConnectorController)

import MonthpickerController from "./monthpicker_controller"
application.register("monthpicker", MonthpickerController)

import PlanFormController from "./plan_form_controller"
application.register("plan-form", PlanFormController)

import MealFoodController from "./meal_food_controller"
application.register("meal-food", MealFoodController)

import RegularTaskController from "./regular_task_controller"
application.register("regular-task", RegularTaskController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SidePanelCloserController from "./side_panel_closer_controller"
application.register("side-panel-closer", SidePanelCloserController)

import SidePanelController from "./side_panel_controller"
application.register("side-panel", SidePanelController)

import SidePanelOpenerController from "./side_panel_opener_controller"
application.register("side-panel-opener", SidePanelOpenerController)

import TaskCompletionController from "./task_completion_controller"
application.register("task-completion", TaskCompletionController)

import TimepickerConnectorController from "./timepicker_connector_controller"
application.register("timepicker-connector", TimepickerConnectorController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import CallController from "./call_controller"
application.register("call", CallController)
